// src/redux/jobDetailsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentJob: null,
  recruiterName: "",
  recruiterFirstName: "",
  recruiterLastName: "",
};

const jobDetailsSlice = createSlice({
  name: "jobDetails",
  initialState,
  reducers: {
    setJobDetails(state, action) {
      const {
        currentJob = null,
        recruiterName = "",
        recruiterFirstName = "",
        recruiterLastName = "",
        recruiters = [],
        recruiterNames = [],
        recruiterCount= 0

      } = action.payload || {};
      state.currentJob = currentJob;
      state.recruiterName = recruiterName;
      state.recruiterFirstName = recruiterFirstName;
      state.recruiterLastName = recruiterLastName;
      state.recruiters = recruiters;
      state.recruiterNames = recruiterNames;
      state.recruiterCount = recruiterCount
    },
    clearJobDetails(state) {
      state.currentJob = null;
      state.recruiterName = "";
      state.recruiterFirstName = "";
      state.recruiterLastName = "";
      state.recruiters = [];
      state.recruiterNames = [];
      state.recruiterCount = 0
    },
  },
});

export const { setJobDetails, clearJobDetails } = jobDetailsSlice.actions;
export default jobDetailsSlice.reducer;
